import { OPEN_ERROR_BOX } from "../constants/actionTypes";
import { defaultAction } from "./defaultAction";
import { getCustomerProfile } from "./getCustomerProfile";

export const updateCustomerConsignmentStatus =
  status => async (dispatch, getState, api) => {
    try {
      const state = getState();
      const { customerInfo } = state;
      await api.put(`v3/customers/risk-consignment`, {
        action: status,
        customerId: customerInfo.internalId
      });
      await dispatch(getCustomerProfile());
    } catch (error) {
      dispatch(
        defaultAction(OPEN_ERROR_BOX, {
          title: "Sorry, something went wrong.",
          message:
            error?.response?.data?.message[0] ||
            "Please contact customer support."
        })
      );
      window.scrollTo(0, 0);
    }
  };

export const getCustomerConsignmentOrders =
  () => async (dispatch, getState, api) => {
    try {
      const { data } = await api.get("v3/customers/risk-consignment");
      return data;
    } catch (error) {
      dispatch(
        defaultAction(OPEN_ERROR_BOX, {
          title: "Sorry, something went wrong.",
          message:
            error?.response?.data?.message[0] ||
            "Please contact customer support."
        })
      );
      window.scrollTo(0, 0);
    }
  };
